import styled from 'styled-components';

import Button from '../../../../CoreWrappers/Button';

export default styled(Button)`
	&.motif-button.motif-button .motif-icon {
		--size: var(--px-20);
	}
`;
